import React from "react";
import { withTranslation } from 'react-i18next';
import { List, Empty } from "antd";


class LeadFormServiceRequestSidebar extends React.Component {
    state = ({

    });


    render() {
        const { data, t } = this.props;

        return (
            <div>
                {
                    data && data.length > 0 ?
                        <List
                            itemLayout="horizontal"
                            dataSource={data}
                            renderItem={item => (
                                <List.Item>
                                    <List.Item.Meta
                                        // avatar={<Avatar src="https://zos.alipayobjects.com/rmsportal/ODTLcjxAfvqbxHnVXCYX.png" />}
                                        title={item.name}
                                        description={
                                            <div>
                                                <b>{item.reason_display}</b> {item.created_on} {
                                                    item.files ?
                                                        <a download target="_blank" href={item.files}>{t('clients.client_service.download', "Download")}</a> :
                                                        ''
                                                }
                                                <br></br>
                                                {item.message}
                                            </div>
                                        }
                                    />
                                </List.Item>
                            )}
                        /> :
                        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                }
            </div>
        );
    }
}

export default withTranslation()(LeadFormServiceRequestSidebar);


// WEBPACK FOOTER //
// ./src/containers/Leads/LeadFormServiceRequestSidebar.js